const triviaNight = {
    title: "Trivia Night!",
    subtitle: "Real-Time Multiplayer Quiz App",
    description: [
        "A full stack real-time multiplayer quiz app using Kotlin Spring Boot, and WebSockets",
    ],
    imgSrc: "/images/trivia-night.png",
    techstack: [
        "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/kotlin/kotlin-original.svg",
        "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/spring/spring-original.svg",
        "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/postgresql/postgresql-original.svg",
        "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/redis/redis-original.svg",
        "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/docker/docker-original.svg",
        "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/kubernetes/kubernetes-plain.svg",
        "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/jenkins/jenkins-original.svg",
    ],
    link: "https://github.com/kyle-t01/multiplayer_live_quiz",
}

const nextReco = {
    title: "NextReco! - AI powered recommendations",
    subtitle: "What if GenAI could make searching easier?",
    description: [
        "A Full-stack MERN app to organise and share recommendations (Recos) with friends.",
        "Generative AI assists users in creating, searching, and filtering Recos",
    ],
    imgSrc: "/images/next-reco.png",
    techstack: [
        "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mongodb/mongodb-original.svg",
        "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/express/express-original.svg",
        "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg",
        "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nodejs/nodejs-original.svg",

        "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/firebase/firebase-original.svg",
    ],
    link: "https://github.com/kyle-t01/next_reco",
}

const parseAndPlay = {
    title: "Parse and Play!",
    subtitle: "Serverless Tool For Writing Music",
    imgSrc: "/images/parse-and-play.png",
    description: ["A lightweight cloud tool that converts text to audio"],
    techstack: [
        "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/terraform/terraform-original.svg",
        "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/github/github-original.svg",
    ],
    link: "https://github.com/kyle-t01/parse_and_play",
}


const tokiPonaDict = {
    title: "Toki Pona Dictionary",
    subtitle: "A tool for learning the world's smallest language",
    description: [
        "Dictionary and Quiz App for learning Toki Pona",
    ],
    imgSrc: "/images/toki-pona-dictionary.png",
    techstack: [
        "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/flutter/flutter-original.svg",
        "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/sqlite/sqlite-original.svg",
    ],
    link: "https://github.com/kyle-t01",
}
const projects = [triviaNight, nextReco, parseAndPlay, tokiPonaDict];
export default projects;